import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as turf from '@turf/turf';

import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';

import { LengthText } from '../../../Common/UI/LengthText';

const propTypes = {
    feature: PropTypes.shape({
        geometry: PropTypes.object.isRequired
    }).isRequired
};

const defaultProps = {

};

const useStyles = makeStyles((theme) => styles(theme));

function LineFeatureProperties ({ feature }) {
    const classes = useStyles();
    // lineDistance returns km by default
    const distance = turf.lineDistance(feature.geometry) * 1000;
    return (
        <div>
            <div className={`${classes.row} ${classes.alignItemsCenter}`}>
                <Typography
                    variant="caption"
                    color="textPrimary"
                    component="div"
                >
                    Distance:
                </Typography>
                <Typography
                    variant="caption"
                    color="textPrimary"
                    align="right"
                    component="div"
                >
                    <LengthText length={distance} />
                </Typography>
            </div>
        </div>
    );
}

const styles = (theme) => ({
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        maxWidth: 200
    },
    alignItemsCenter: {
        alignItems: 'center'
    }
});

LineFeatureProperties.propTypes = propTypes;
LineFeatureProperties.defaultProps = defaultProps;

export default LineFeatureProperties;